/** @format */

import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

import {People} from 'mixpanel-browser';

import {useMixpanelContext} from '../../contexts/MixpanelContext';
import {detailsPageLink} from '../checkHelpers';
import {sensorName} from '../sensor_names';

interface ReturnRouteSensorPage {
  onSensorClick: (name: string) => void;
}

const useRouteSensorPage = (): ReturnRouteSensorPage => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const {mixpanel: untypedMixpanel} = useMixpanelContext();
  const mixpanel = untypedMixpanel as typeof untypedMixpanel & {people: People};

  const onSensorClick = (name: string) => {
    const snakeCaseName = name.replace(/-/g, '_');
    mixpanel.people.increment(`open_${snakeCaseName}_page_count`);
    mixpanel.track(`open_${snakeCaseName}_page`);
    mixpanel.track('open_sensor_page', {sensor_name: snakeCaseName});

    const link = detailsPageLink(name, t(sensorName(name)));
    navigate(link);
  };

  return {onSensorClick};
};

export {useRouteSensorPage};
